import { Link, useParams } from "react-router-dom";
import ProjectShowcase from "@/components/project/Sections";
import { getProjectBySlug } from "@/data/projects";

export default function ProjectPage() {
    const { slug } = useParams();
    const project = getProjectBySlug(slug);

    if (!project || project.visibility === "private") {
        return (
            <div
                className="mx-auto max-w-7xl px-5 pb-24 pt-44 text-center sm:px-8"
                data-testid="project-unavailable"
            >
                <p className="eyebrow">Showcase Unavailable</p>
                <h1 className="mt-4 font-serif text-4xl text-ivory">
                    This page is private or no longer listed.
                </h1>
                <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-mist">
                    Some Sthaan showcases are shared privately. Explore the public
                    collection instead.
                </p>
                <Link
                    to="/discover"
                    data-testid="project-unavailable-cta"
                    className="mt-8 inline-block rounded-full bg-gold px-7 py-3 text-sm font-semibold text-obsidian transition-colors hover:bg-gold-bright"
                >
                    Discover projects
                </Link>
            </div>
        );
    }

    return <ProjectShowcase project={project} />;
}
